<template>
	<transition name="fade">
		<!-- Content -->
		<Content 
			title="Salary Adjustment Types"
			@create="create"
			createText="Upload"
		>

			<!-- Table -->
				<c-table
					ref="myTable"
					:items="items" 
					:fields="fields" 
					:per-page="15" 
					:total="items ? items.length : 0"
					:isBusy="isLoading"

					hover striped bordered small fixed 
				/>

			<!-- Form -->
			<Form ref="myForm" />


		</Content>
	</transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Content from "../components/Content";
import cTable from '../../base/PayrollDataTable';
import Form from './components/AdjustmentTypeForm';


const fields = [
				{
					label: "Salary Adjustment Type",
					key: "SalaryAdjustmentTypeName",
					sortable: true
				},
				{
					label: "Entry",
					key: "Entry",
					sortable: true
				},
];

export default {
	name: 'PayrollSalaryAdjustmentType',
	components:{
		Content,
		cTable,
		Form
	},
	data(){
		return {	
			fields: fields,
			isLoading: true,
		}
	},
	methods:{
		...mapActions(
			{
				index:'getPayrollSalaryAdjustmentTypes',
			},
		),
		create(){
			this.$refs.myForm.show();
		},
	},

	computed:{
		...mapGetters(
			{ items: 'payroll_salary_adjustment_types', response: 'response'}
			)
	},
	mounted(){
		this.index()
			.then(response => {
				this.isLoading = false;
			})
	}
}
</script>	